import React, { useEffect, useState } from "react";
import { Styles } from "./styles";
import { Col, Container, Row } from "react-bootstrap";
import ReactImg from "../../../assets/images/backGrounds/react.svg";
import { t } from "i18next";
import { getAllAdministrativeStaff } from "../../../services/home.service";
import Loader from "../../common/loader/Loader";
import { useSelector } from "react-redux";
import { Fade } from "react-reveal";
import Spin from "react-reveal/Spin";

const AdministrativeStaff = () => {
  // language data from store
  const Resource = useSelector((state) => state.translation.resource);

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();
  const getData = async () => {
    setIsLoading(true);
    const response = await getAllAdministrativeStaff();
    if (response?.status === 200) {
      setData(response?.data?.data);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <Styles>
      {isLoading ? (
        <Loader />
      ) : (
        data?.length > 0 && (
          <section id="administrativeStaffSection">
            <Spin>
              <img className="react-img" src={ReactImg} alt="react image" />
            </Spin>
            <Container>
              <Fade bottom>
                <h2 className="section-title">
                  {Resource?.administrative_staff_title
                    ? Resource?.administrative_staff_title
                    : t("home.administrative_staff.title")}
                </h2>
              </Fade>
              <Row>
                {data?.map((item, idx) => {
                  return (
                    <Col key={idx} lg={3} md={6}>
                      <Fade right>
                        <div className="item">
                          <div className="item-img">
                            {item?.image ? (
                              <img
                                src={item?.image}
                                alt={item?.localizedName}
                              />
                            ) : (
                              <div className="avatar">
                                <svg
                                  id="user"
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="23.867"
                                  height="30.3"
                                  viewBox="0 0 23.867 30.3"
                                >
                                  <path
                                    id="Path_1384"
                                    data-name="Path 1384"
                                    d="M23.4,10.7A7.7,7.7,0,1,1,15.7,3a9.041,9.041,0,0,1,2.047.275C20.712,3.818,23.4,6.945,23.4,10.7Zm-3.85,0A3.85,3.85,0,1,1,15.7,6.85,3.85,3.85,0,0,1,19.55,10.7Z"
                                    transform="translate(-3.766 -3)"
                                    fill="#fff"
                                    fillRule="evenodd"
                                  />
                                  <path
                                    id="Path_1385"
                                    data-name="Path 1385"
                                    d="M25.891,17.967A1.989,1.989,0,0,0,23.9,15.978H11.967a1.989,1.989,0,0,0-1.989,1.989V29.9H6V17.967A5.967,5.967,0,0,1,11.967,12H23.9a5.967,5.967,0,0,1,5.967,5.967V29.9H25.891Z"
                                    transform="translate(-6 0.4)"
                                    fill="#fff"
                                  />
                                </svg>
                              </div>
                            )}
                          </div>
                          <div className="item-description">
                            <div className="name">{item?.localizedName}</div>
                            <div className="job-title">
                              {item?.localizedDescription}
                            </div>
                          </div>
                        </div>
                      </Fade>
                    </Col>
                  );
                })}
              </Row>
            </Container>
          </section>
        )
      )}
    </Styles>
  );
};

export default AdministrativeStaff;
